import NavigableValidation from "./navigableValidation";
import {AllValidationErrorTypes, ErrorType, ErrorTypes, WarningTypes} from "~/enums/ErrorType"
import ErrorCategories, {TErrorCategories} from "./errorArray";
import {ValidationErrorLevel} from "~/models/validationError";

export default class ValidationErrorCollection {
  collection: {[key: string]: TErrorCategories} = {};

  constructor(validation: NavigableValidation<any>) {
    if (validation.SECTIONS) {
      Object.keys(validation.SECTIONS).forEach(section => {
        this.collection[section] = ErrorCategories.categories();
      });
    }
  }

  getSectionErrors(sectionName, types: Array<ErrorType> = ErrorTypes, level: ValidationErrorLevel = ValidationErrorLevel.All) {

    let errors = [];
    types.forEach((errorType)=>{
      this.collection[sectionName][errorType].forEach((error)=> {
        if (level === ValidationErrorLevel.All || error.level === level) errors.push(error);
      });
    });
    return errors
  }

  getSectionErrorsCount(sectionName) {
    return this.getSectionErrors(sectionName, ErrorTypes).length
  }

  getSectionWarningsCount(sectionName) {
    return this.getSectionErrors(sectionName, WarningTypes).length
  }

  getErrors(level: ValidationErrorLevel = ValidationErrorLevel.All, targetTypes?: Array<ErrorType>) {
    let errors = [];

    let types;
    if (!targetTypes) {
      if (level === ValidationErrorLevel.Error) {
        types = ErrorTypes
      } else if (level === ValidationErrorLevel.Warning) {
        types = WarningTypes
      } else types = AllValidationErrorTypes
    } else {
      types = targetTypes.slice()
    }

    for (let sectionName in this.collection){
      errors.push(...this.getSectionErrors(sectionName, types, level))
    }

    return errors;
  }

  hasError(type: ErrorType, level: ValidationErrorLevel = ValidationErrorLevel.Error) {
    return this.getErrors(level).filter(err => {
      return err.type === type
    }).length > 0
  }

  errorLevelCount(level: ValidationErrorLevel = ValidationErrorLevel.All): number {
    return this.getErrors(level).length
  }
}